import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import './style/index.css';
import './style/fonts.css';
import './style/buttons.css';
import './i18n';
import {Provider} from 'react-redux';
import store, {history} from "./reducers/store";
import {ConnectedRouter} from 'connected-react-router'
import {Route, Switch} from "react-router";
import AuthenticationError from "./containers/AuthenticationError";
import App from "./App";
import PublicFaqPage from "./containers/PublicFaqPage";

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path="/public/faq" exact component={PublicFaqPage}/>
                <Route path="/" component={App}/>
            </Switch>
            <AuthenticationError/>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);